import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("App-Fehler:", error, info?.componentStack);
  }

  reload = async () => {
    try {
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch {
      // ignorieren
    }
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", padding: 24, fontFamily: "system-ui, sans-serif" }}>
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <div style={{ fontSize: 40 }}>⚠️</div>
          <h1 style={{ fontSize: 20, fontWeight: 700, color: "#171717", marginTop: 12 }}>Ups — da ist etwas schiefgelaufen</h1>
          <p style={{ fontSize: 14, color: "#737373", marginTop: 8 }}>
            Die Seite konnte nicht geladen werden. Meist hilft ein Neuladen — dabei wird auch die neueste App-Version geholt.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={this.reload}
            style={{ marginTop: 20, padding: "12px 24px", borderRadius: 12, border: "none", background: "#171717", color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer" }}
          >
            App neu laden
          </button>
        </div>
      </div>
    );
  }
}
